import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js'
import { createBrowserHistory } from 'history'
import { getConfig } from '../configs/config'

const browserHistory = createBrowserHistory({ basename: '' })
const userData = localStorage.getItem('userData')
  ? JSON.parse(localStorage.getItem('userData'))
  : null
const reactPlugin = new ReactPlugin()
const config = getConfig()
const ai = new ApplicationInsights({
  config: {
    connectionString:
      config?.APP_INSIGHTS_CONNECTION_STR ||
      'InstrumentationKey=f5de0f0c-0845-4f13-8bfe-4f0b61429f5e;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=fe917f39-a614-446b-9777-a771522e4c64',
    extensions: [reactPlugin],
    enableAutoRouteTracking: true,
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory }
    }
  }
})
const customProps = {
  AppName: 'Smart Insights',
  UserEmail: userData?.username || null
}
ai.loadAppInsights()
ai.trackPageView({
  properties: customProps
})

export default (Component) => withAITracking(reactPlugin, Component)
export const appInsights = ai.appInsights
export { ai, reactPlugin }
export { customProps }
